import { HubItemMediaPreviewViewModel } from "client/Api/Hub/common";
import { TimeZone } from "client/DateAndTime/timezones";
import { KnowledgeItemListItem } from "client/Features/Hub/KnowledgeItems/ListItem/KnowledgeItemListItem";
import { generateTrackingId } from "client/Misc/utils";
import { ReactElement, useMemo } from "react";
import { convertHubMedia } from "client/Features/Search/RecentSearch/Persistence/convertPersistedData";
import { GlobalSearchResultItemKind, GlobalSearchScopeIdentifier } from "client/Api/TitleBar/GlobalSearch/globalSearch";
import { GlobalSearchItem } from "../../../GlobalSearchItem/GlobalSearchItem";
import { useKnowledgeItemNavigationHandler } from "../../../Navigation/useKnowledgeItemNavigationHandler";
import { ValidGlobalSearchItemPersistedModel } from "client/Features/Search/RecentSearch/Persistence/validation";

export type KnowledgeItemViewProps = {
	item: ValidGlobalSearchItemPersistedModel<GlobalSearchResultItemKind.KnowledgeItems>;
	itemIndex: number;
	onRemove: () => void;
	timezone: TimeZone;
	itemScope: GlobalSearchScopeIdentifier;
	tabIndex: number;
};

export const KnowledgeItemView = (props: KnowledgeItemViewProps): ReactElement => {
	const {
		item,
		itemIndex,
		onRemove,
		timezone,
		tabIndex
	} = props;

	const {
		id,
		title,
		category,
		author,
		lastModifiedDate,
		media: persistedMedia
	} = item.knowledgeItem;

	const media = useMemo(
		(): HubItemMediaPreviewViewModel => convertHubMedia(persistedMedia),
		[persistedMedia]
	);

	const openHandler: () => void = useKnowledgeItemNavigationHandler({
		id,
		recentlyOpenedItem: item
	});

	return (
		<GlobalSearchItem
			trackingId={generateTrackingId("knowledge-item", `|${id}`)}
			onClick={openHandler}
		>
			<KnowledgeItemListItem
				title={title}
				categoryName={category?.name}
				authorName={author?.name}
				lastModifiedDate={lastModifiedDate}
				media={media}
				trackingId={generateTrackingId("knowledge-item-result-list-item", `|${id}`)}
				timezone={timezone}
				onRemove={onRemove}
				itemIndex={itemIndex}
				tabIndex={tabIndex}
				onExecute={openHandler}
			/>
		</GlobalSearchItem>
	);
};
KnowledgeItemView.displayName = "KnowledgeItemView";